import initAccordion from './components/accordion';
import { scrollToEls } from './global/scrollTo';
import headerInit from './sections/header/headerInit';
import initFaqsNav from './components/faqsNav';
import cookieWarning from './dom/cookieWarning';
import { clickToggle } from './global/clickToggle';
import { onShopifySectionLoad, ready } from './global/instantiate';
import { sizeChartConversion } from './global/sizeChartConversion';
import quantityAdjustersInit from './components/quantityAdjuster';
import initialiseZoom from './components/productZoom';
import { sizeChartTabs } from './global/sizeChartTabs';
import announcementsInit from './components/announcements';
import initFooterBar from './components/footer-bar';
import shippingBarsInit from './components/shippingBar';
import calculateInternationalSizing from './dom/calculateInternationalSizing';
import scrollDirectionInit from './dom/scrollDirectionEvent';
import searchClose from './dom/searchClose';
import initSmoothScrolls from './dom/smoothScrolls';
import switcherSizing from './dom/switcherSizing';
import bambuserify from './global/bambuser';
import { initGeo } from './global/geo';
import getCountry from './global/getCountry';
import handleNewsletterSubmit from './global/handleNewsletterSubmit';
import initInputValidator from './global/inputValidator';
import initResponsiveVideo from './global/responsiveVideo';
import setWindowWidth from './global/responsiveWindow';
import initCreateAccountWithBloomreach from './sections/account/createAccountWithBloomreach';
import { trackClick, trackAdd, trackPayment } from '../app-layer/context/search/services/Voyado/notifications';
import { getVoyadoSession, hasCookieConsent } from '../app-layer/context/search/services/Voyado/helpers/voyadoHelpers';
import { localStorageBackedSession } from '@apptus/esales-api';
import {
  enabledButtonOnEmailEntered,
  initChangePassword,
  initDisplayForgotPasswordPage,
  toggleForgotPassword
} from './sections/account/forgot-password';
import { initAccountMobileMenu } from './sections/account/menu';
import addToCartBtnInit from './sections/cart/addToCart';
import confetti from './sections/cart/confetti';
import initQuantitySelector from './sections/cart/quantitySelector';
import manualModalOpen from './sections/product/manualModalOpen';
import { initSort } from './sections/products/sort';
import { initProductVideo } from './sections/productVideo';
import { swipify, swipifyMob } from './dom/swipify';
import getHeaderHeight from './global/getHeaderHeight';
import initViewSwitcher from './global/viewSwitcher';
import { initVideo } from './dom/initVideo';
import { glidify, glidifyMob } from './dom/glidify';

//example for global-e:
//window.addEventListener('blubolt:priceChange', (e) => console.info(e))

// Helper functions
const defaultWindowBlubolt = {
  dom: {
    initialiseZoom,
    calculateInternationalSizing,
    swipify,
    swipifyMob
  },
  device: '',
  swiperObjects: [],
  swiperMobileObjects: []
};

// Update the window.blubolt initialization logic
if (!window.blubolt) {
  window.blubolt = defaultWindowBlubolt;
} else {
  window.blubolt = {
    ...defaultWindowBlubolt, // Put defaultWindowBlubolt first
    ...window.blubolt // Then spread existing properties
  };
}

ready(() => {
  getHeaderHeight();
  scrollDirectionInit();
  handleNewsletterSubmit();
  headerInit();
  clickToggle();
  sizeChartTabs();
  sizeChartConversion();
  manualModalOpen();
  quantityAdjustersInit();
  cookieWarning();
  initSort();
  toggleForgotPassword();
  enabledButtonOnEmailEntered();
  initDisplayForgotPasswordPage();
  initChangePassword();
  initAccountMobileMenu();
  initQuantitySelector();
  initInputValidator();
  initialiseZoom('[data-main-product-image-wrapper]', 2);
  scrollToEls();
  addToCartBtnInit();
  calculateInternationalSizing();
  switcherSizing();
  initGeo();
  initAccordion();
  initFooterBar();
  initProductVideo();
  bambuserify();
  searchClose();
  initSmoothScrolls();
  initResponsiveVideo();
  setWindowWidth();
  initCreateAccountWithBloomreach();
  swipify();
  swipifyMob();

  confetti();
  // B2B pricing now handled in React (getProductPrice.ts) - no longer needed here
  // if (window.theme.isb2b) {
  //   console.log('b2b global')
  //   b2bPricing();
  // }
  initViewSwitcher();
  getCountry(country => {
    //anything requires geolocation can go here

    const deliveryPromise = document.querySelector('.confidence-delivery');
    const deliveryPromiseUSA = document.querySelector('.confidence-delivery-usa');

    if (deliveryPromiseUSA && country.handle === 'UK') {
      // Show UK delivery promise, hide US
      deliveryPromiseUSA.classList.add('hide');
    } else if (deliveryPromise && country.handle === 'US') {
      // Show US delivery promise, hide UK
      deliveryPromiseUSA.classList.remove('hide');
      deliveryPromise.classList.add('hide');
    }

    announcementsInit();

    const shippingBanner = document.querySelector('#fsb_placeholder');
    if (shippingBanner && country.handle !== 'GB') {
      shippingBanner.classList.add('hide');
    }
    shippingBarsInit();
  });

  if (window.blubolt.SearchService === 'voyado' && !window.blubolt.Voyado?.initialized) {
    trackClick();
    trackAdd();
    // Expose Voyado functions for use in Liquid templates and checkout extensions
    window.blubolt.Voyado = window.blubolt.Voyado || {};
    window.blubolt.Voyado.trackPayment = trackPayment;
    window.blubolt.Voyado.getVoyadoSession = getVoyadoSession;
    window.blubolt.Voyado.hasCookieConsent = hasCookieConsent;
    window.blubolt.Voyado.localStorageBackedSession = localStorageBackedSession;
    window.blubolt.Voyado.initialized = true;
  }
});

onShopifySectionLoad(() => {
  ready();
});

window.addEventListener('DOMContentLoaded', () => {
  const mainHeader = document.querySelector('[data-main-header]');
  if (!mainHeader) return;
  const mainHeaderChecker = mainHeader.classList.contains('header-section-inner');
  if (mainHeaderChecker !== true) {
    mainHeader.classList.add('header-section-inner');
  }
});
